var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { id: "balance-add", "show-footer": false, "show-title": false },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("billing.balanceTopUp"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", [_vm._v(_vm._s(_vm.$t("settings.ballanceToTransferred")))]),
          _vm._v(" "),
          _c("a-input", {
            staticClass: "supsis-input",
            attrs: { type: "number" },
            model: {
              value: _vm.price,
              callback: function ($$v) {
                _vm.price = $$v
              },
              expression: "price",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "balance-details" }, [
        _c("div", { staticClass: "detail" }, [
          _c("div", { staticClass: "detail-title" }, [
            _vm._v(_vm._s(_vm.$t("settings.availableBalance"))),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.formatPrice(_vm.wallet.whatsapp.amount)) + "TL"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail" }, [
          _c("div", { staticClass: "detail-title" }, [
            _vm._v(_vm._s(_vm.$t("settings.balanceReceived"))),
          ]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.formatPrice(_vm.price)) + "TL")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail" }, [
          _c("div", { staticClass: "detail-title" }, [
            _vm._v(_vm._s(_vm.$t("settings.totalBalance"))),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(_vm.formatPrice(_vm.wallet.whatsapp.amount + +_vm.price)) +
                "TL"
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "card-title" }, [
          _vm._v(_vm._s(_vm.$t("settings.paymentCard"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "current-card" }, [
          _c("div", { staticClass: "card-information" }, [
            _c(
              "div",
              { staticClass: "card-type-logo" },
              [_c("DynamicSvg", { attrs: { name: _vm.formatedType() } })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-detail" }, [
              _c("div", { staticClass: "card-bin-number" }, [
                _vm._v(_vm._s(_vm.formatedNumber())),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-type" }, [
                _vm._v(_vm._s(_vm.billingDetail.cardAssociation)),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "balance-footer" }, [
        _c(
          "div",
          { staticClass: "supsis-modal-button", on: { click: _vm.cancel } },
          [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "supsis-modal-button second",
            on: { click: _vm.submit },
          },
          [_vm._v(_vm._s(_vm.$t("message.save")))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }